import {createEventBus} from "../../../utils/eventBus";
import {SongDuration} from "../../../store/slices/player/types";

export interface PlayerEvents {
    play: void;
    pause: void;
    next: void;
    prev: void;
    duration: SongDuration;
    seek: number; // (number -> time to seek to)
    resetProgress: void;
    // Cast session ended — seed the local iframe with the receiver's last position
    // so resume picks up where the TV left off. Distinct from `seek` so MediaSource
    // doesn't have to disambiguate via stale isCasting refs (Redux/useEffect lag).
    castHandoff: number;
}

export const PlayerEventBus = createEventBus<PlayerEvents>();
